import { ref } from 'vue'
import { defineStore } from 'pinia'
import { getConfig } from '@/api/app'

export const useAppStore = defineStore('app', () => {
  const config = ref(null)

  const fetchConfig = async (_config) => {
    if (config.value) return config.value
    if (Object.keys(_config || {}).length > 0) {
      config.value = _config
      return config.value
    }
    try {
      const { code, data, message } = await getConfig()
      if (code === 0) {
        if (!data?.uuid && !import.meta.env.SSR) {
          // 不使用SSR生成的UUID值
          data.uuid = window.uuidv4()
        }
        config.value = data
      } else throw Error({ code, data, message })
    } catch (error) {
      console.error(error)
      config.value = {
        uuid: import.meta.env.SSR ? '12345678-1234-5678-1234-123456789abc' : window.uuidv4()
      }
    }
    !import.meta.env.SSR && localStorage.setItem('uuid', config.value?.uuid || window.uuidv4())
    return config.value
  }

  return { config, fetchConfig }
})
